import React, { useMemo, useState, useEffect } from "react";
import MaterialReactTable from "material-react-table";
import axios from "axios";
import ReactModal from "react-modal";
import Cookies from "universal-cookie";
import * as IoIcons from "react-icons/io";
import { obtenerRepresentanteLegal } from "../../Services/Rest";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { Box, IconButton, Tooltip } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import { useCallback } from "react";
import Swal from "sweetalert2";

const cookie = new Cookies();

const grupos = ["1", "2", "3"];
const RepresentanteAdmin = (props) => {
  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "Id",
        filterVariant: "text",
        enableEditing: false, //disable editing on this column
      },
      {
        accessorKey: "institucion",
        header: "Institucion",
        filterVariant: "text",
        enableEditing: false, //disable editing on this column
      },
      {
        accessorKey: "nombre",
        header: "Nombre",
        filterVariant: "text",
        enableEditing: false, //disable editing on this column
      },

      {
        accessorKey: "tipo_Documento",
        header: "Tipo Documento",
        filterVariant: "text",
        //disable editing on this column
      },
      {
        accessorKey: "teleFonoContacto",
        header: "Telefono Contacto",
        filterVariant: "text",
      },
      {
        accessorKey: "ciudad",
        header: "Ciudad",
        filterVariant: "text",
      },
      {
        accessorKey: "direccion",
        header: "Direccion",
        filterVariant: "text",
      },
      {
        accessorKey: "correo",
        header: "Correo",
        filterVariant: "text",
      },
    ],
    [],
  );

  const cookie = new Cookies();

  const [list1, setList1] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: obtenerRepresentanteLegal,
    })
      .then((Response) => {
        setList1(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList1]);

  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [tableData, setTableData] = useState(() => list1);
  const handleSaveRow = async ({ exitEditingMode, row, values }) => {
    axios({
      method: "put",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ActualizaRepresentanteLegal?Id=" +
        values.id,
      data: values,
    })
      .then((Response) => {
        alert("Actualizado con exito!");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al Actualizar" + error);
      });
    //send/receive api updates here
    setTableData([...tableData]);
    exitEditingMode(); //required to exit editing mode
  };
  const handleDeleteRow = useCallback((row) => {
    axios({
      method: "delete",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },

      url:
        "https://middlewareback.azurewebsites.net/api/v1/RevocarCredencial/" +
        row.getValue("id"),

      data: {
        estado: "Revocado",
      },
    })
      .then((Response) => {
        Swal.fire({
          title: Response.data,
          text: "Actualizado",
          icon: "success",
          buttons: true,
          dangerMode: true,
        }).then((willDelete) => {
          if (willDelete) {
            console.log(Response.data);

            window.location.reload("/");
          } else {
            Swal.fire("Your imaginary file is safe!");
          }
        });
      })
      .catch((error) => {
        Swal.fire({
          title: "Error!" + error,
          text: "verifique los campos",
          icon: "error",
          timer: 4000,
        });
      });
  });

  return (
    <div>
      <div className="container">
        <div className="text-center">
          <div className="container-fluid">
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <h6 className="m-0 font-weight-bold text-primary">
                  Representante Legal
                </h6>
                <div className="row"></div>
                <hr />
                {cookie.get("tipo_Usuario") == 1 ? (
                  <MaterialReactTable
                    localization={MRT_Localization_ES}
                    columns={columns}
                    data={list1}
                    initialState={{ showColumnFilters: true }}
                    enableRowActions
                    editingMode="modal" //default
                    enableEditing
                    onEditingRowSave={handleSaveRow}
                    renderRowActions={({ row, table }) => (
                      <Box sx={{ display: "flex", gap: "1rem" }}>
                        <Tooltip arrow placement="left" title="Edit">
                          <IconButton onClick={() => table.setEditingRow(row)}>
                            <Edit />
                          </IconButton>
                        </Tooltip>
                        <Tooltip arrow placement="right" title="Delete">
                          <IconButton
                            color="error"
                            onClick={() => handleDeleteRow(row)}
                          >
                            <Delete />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    )}
                  />
                ) : (
                  <h1></h1>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RepresentanteAdmin;
